export default __webpack_public_path__ + "static/optical-adjustment-dont-c61905a6b792ccdc3ad2bf6f24162e04.png";